// import minigrid from './minigrid.js';
// import Blazy from './blazy.js';
import'./nav.js';
import'./menu.js';



// WEBPACK FOOTER //
// ./main.js